<script>
  export default {
    name: 'll-list-item-cell',

    props: {
      /**
       * Is this cell for the Action column
       */
      isAction: Boolean,
    },
  };
</script>

<template>
  <div :class="isAction ? $style.action : $style.cell">
    <slot></slot>
  </div>
</template>

<style module>
  @reference "../../../styles/main.css";

  @layer utilities {
    .cell {
      background-color: var(--color-ice-100);
      border-radius: var(--radius-sm);
      padding: --spacing(1.5);

      :global(.stash-label) {
        font-size: var(--text-xs);
      }

      @media (width >= theme(--breakpoint-lg)) {
        background: none;
        padding: 0;

        :global(.stash-label) {
          display: none !important;
        }
      }
    }

    .action {
      position: absolute;
      right: 0;
      top: 0;

      @media (width >= theme(--breakpoint-lg)) {
        position: initial;
      }
    }
  }
</style>
